import React, { Component } from 'react';
import { legendContent } from './utils'

class ChartLegend extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { chartConfig, chartData, metricColumns, align, selectedLegends, onLegendClick } = this.props;
    const streams = chartConfig?.dataStreams?.streams || []
    const names = (Array.isArray(chartData.uniqueGroupValues) && chartData.uniqueGroupValues.length > 0)
      ? chartData.uniqueGroupValues
      : (Array.isArray(metricColumns) ? metricColumns : [])
    const payload = names.map((name, idx) => ({
      value: streams[idx]?.streamLabel?.value || name,
      type: 'square',
      id: name,
      payload: { metric: name },
      color: streams[idx]?.streamLabel?.color || '#888'
    }))

    const content = legendContent({
      payload,
      align,
      dataOverrides: chartConfig?.yDataOverrides,
      chartConfig,
      selectedLegends,
      onLegendClick
    })

    return content
  }
}

export default ChartLegend;